import type { SkillTypes } from "@memorang/types";
import type { ReactNode } from "react";
import type { HintAccordionProps } from "../../../HintAccordion";
import HintAccordion from "../../../HintAccordion";
import ChoicesList, { type ChoicesListProps } from "../ChoicesList";
import StimulusLayout from "./StimulusLayout";

export type MultipleChoiceReadingProps = Pick<
	ChoicesListProps,
	| "choices"
	| "itemId"
	| "handleSelectChoice"
	| "selectedChoiceIds"
	| "correctAnswerIds"
	| "crossedOutChoiceIds"
	| "isAnswered"
	| "useCardWrapper"
	| "showCrossOut"
	| "isSummativeTest"
	| "inReviewMode"
	| "numChoicesRequired"
	| "multiSelect"
> & {
	stimulusText?: string;
	stem: string;
	instruction: string;
	subInstruction?: string;
	skill?: SkillTypes;
	shuffle?: boolean;
	hintAccordionProps?: HintAccordionProps;
	renderHint?: () => ReactNode;
	renderFeedback?: () => ReactNode;
};

const MultipleChoiceReading = ({
	stimulusText,
	stem,
	instruction,
	subInstruction,
	skill,
	choices,
	itemId,
	selectedChoiceIds,
	correctAnswerIds,
	crossedOutChoiceIds,
	isAnswered,
	useCardWrapper,
	showCrossOut,
	isSummativeTest,
	inReviewMode,
	multiSelect,
	numChoicesRequired,
	handleSelectChoice,
	shuffle = false,
	hintAccordionProps,
	renderHint,
	renderFeedback,
}: MultipleChoiceReadingProps) => {
	return (
		<StimulusLayout
			stimulusText={stimulusText ?? ""}
			instruction={instruction}
			subInstruction={subInstruction}
			skill={skill}
			stem={stem}
			showDivider={false}
			renderFeedback={renderFeedback}
			isAnswered={isAnswered}
		>
			<ChoicesList
				choices={choices}
				handleSelectChoice={handleSelectChoice}
				selectedChoiceIds={selectedChoiceIds}
				correctAnswerIds={correctAnswerIds}
				crossedOutChoiceIds={crossedOutChoiceIds}
				isAnswered={isAnswered}
				useCardWrapper={useCardWrapper}
				showCrossOut={showCrossOut}
				isSummativeTest={isSummativeTest}
				inReviewMode={inReviewMode}
				multiSelect={multiSelect}
				numChoicesRequired={numChoicesRequired}
				itemId={itemId}
				shuffle={shuffle}
			/>
			{renderHint?.() ??
				(hintAccordionProps ? <HintAccordion {...hintAccordionProps} /> : null)}
		</StimulusLayout>
	);
};

export default MultipleChoiceReading;
